export { default } from './pharmacy-and-services.component';
